__turbopack_context__.v({
  "error": "controlledInput-module__BomF-G__error",
  "errorContainer": "controlledInput-module__BomF-G__errorContainer",
  "errorText": "controlledInput-module__BomF-G__errorText",
  "label": "controlledInput-module__BomF-G__label",
  "mainInput": "controlledInput-module__BomF-G__mainInput",
  "passwordButton": "controlledInput-module__BomF-G__passwordButton",
  "passwordContainer": "controlledInput-module__BomF-G__passwordContainer",
});
